import classNames from 'classnames'
import styles from './CloseButton.module.css'
import CloseIcon from '@mui/icons-material/Close'

interface CloseButtonProps{
    onClick: (event: any) => void
    className?: string
}

export const CloseButton = (props: CloseButtonProps): JSX.Element => {
    const {
        className,
        onClick
    } = props

    const closeButtonClasses = classNames(styles.CloseButton, className)

    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }

    return (
        <button
            className={closeButtonClasses}
            onClick={handleButtonClick}
        >
            <CloseIcon
                className={styles.CloseButton__Icon}
            />
        </button>
    )
}